/* Maverno – zet de maattabel-knop (Kiwi of thema) altijd rechts naast het label van de maatkiezer. */
(function () {
  if (window.__mvSizeChart) return;
  window.__mvSizeChart = true;

  var SIZE_RE = /^(maat|maten|size|sizes|schoenmaat|shoe ?size|confectiemaat)\b/i;
  var COLOR_RE = /^(kleur|kleuren|color|colour)\b/i;
  var MOVABLE = '.ks-chart-container, .ks-calculator-container, .sizing-chart.product-popup-modal__opener';

  function optionName(input) {
    var field = input.querySelector('input[type="radio"], select');
    var name = field ? (field.getAttribute('name') || '') : '';
    name = name.replace(/^options\[/, '').replace(/\]$/, '');
    var label = input.querySelector('.form__label');
    return { raw: name, label: label ? label.textContent.trim() : '' };
  }

  function findTarget(scope) {
    var inputs = scope.querySelectorAll('.product-form__input');
    var fallback = null;
    for (var i = 0; i < inputs.length; i++) {
      var container = inputs[i].querySelector('.product-form__label-container');
      if (!container) continue;
      if (/quantity/.test(inputs[i].className) || inputs[i].querySelector('.quantity, quantity-input')) continue;
      var n = optionName(inputs[i]);
      if (/^aantal\b/i.test(n.label)) continue;
      if (SIZE_RE.test(n.raw) || SIZE_RE.test(n.label)) return container;
      if (!COLOR_RE.test(n.raw) && !COLOR_RE.test(n.label)) fallback = container;
    }
    return fallback;
  }

  function place(root) {
    var info = document.querySelector('product-info.main-product__info-container') || document.querySelector('.main-product__info-container');
    if (!info) return;
    var target = findTarget(info);
    if (!target) return;
    target.classList.add('mv-size-row');
    (root || document).querySelectorAll(MOVABLE).forEach(function (el) {
      if (el.closest('.sticky-atc, quick-add-modal')) return;
      if (el.parentElement === target) return;
      target.appendChild(el);
    });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { place(document); }, 60);
  }

  function start() {
    place(document);
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches(MOVABLE) || node.querySelector(MOVABLE) || node.matches('.product-form__input, variant-selects, variant-radios')) {
            schedule();
            return;
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
